export const AuthApi = {
    LOGIN: 'admin/login',
    FORGET_PASSWORD: 'admin/forgot-password',
    FORGET_PASSWORD_TOKEN_VERIFY: 'admin/changepassword/:token',
    CHANGE_PASSWORD: 'admin/update-password/:token',
}